import { ShopConfig, ShopPosition } from 'alice-bob';
import Subtitle from '../subtitle/Subtitle';
import Entry from './entry/Entry';
import { TopUpVFX } from '../../../../../../app/scenes/game/vfx/topup/TopUpVFX';
import { HardCurrency as HCurrency } from '../../../gui/hard-currency/HardCurrency'
import { $shop } from '../../../../../../app/backend/store/shop';

export default class HardCurrency extends Phaser.GameObjects.Container {
    private subtitle!: Subtitle;
    private vfx: TopUpVFX;
    private entries: Array<Entry> = new Array();

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.setupSubtitle();
        // this.setupEntries();

        this.vfx = new TopUpVFX(scene, 5, 'gui/hard_currency/icon', HCurrency.globalPositionOfIcon, { min: 50, max: 150 })
        this.scene.add.existing(this.vfx)

        $shop.watch(data => this.setupEntries(data))
    }

    private setupSubtitle(): void {
        this.subtitle = new Subtitle(this.scene, this.x, this.y, this.scene.cache.json.get('i18n')['gems']);
        this.add(this.subtitle);
    }

    private setupEntries(data: ShopConfig): void {
        if (this.entries.length != 0) {
            this.remove(this.entries);
            this.entries = new Array();
        }
        const startX = -205;
        const startY = 360;
        const width = 204;
        const height = 293;

        if (!data || !data.gems) return;

        const offers = data.gems
        let offerId = 0

        for (let y = 0; y < 2; y++) {
            for (let x = 0; x < 3; x++) {
                const offer = offers[offerId++];
                if (!offer) break;

                const xx = startX + x * width;
                const yy = startY + y * height;

                const entry = new Entry(this.scene, xx, yy, offer, this.vfx);
                this.entries.push(entry)
            }
        }

        this.add(this.entries);
    }
}
